import { FC } from 'react';
import { TBaseTable } from '@mgm/common/components/table';
import { CustomToolbar } from '../../../../components/table';

const TeamTableHeader: FC<TBaseTable> = ({
  apiRef,
  printRef,
  handleScrollTable,
  isFullTable = false,
  setIsFullTable = () => {},
  handleExport,
}) => (
  <CustomToolbar
    isFullTable={isFullTable}
    setFullTable={setIsFullTable}
    handleScrollTable={handleScrollTable}
    printRef={printRef}
    apiRef={apiRef}
    handleExport={handleExport}
  />
);

export {
  TeamTableHeader,
};
